export const brandIdGETPath = () => '/auth/brand';
